module.exports = __webpack_public_path__ + "static/img/stay-option-icon-heating.48265be8.svg";